import { render, staticRenderFns } from "./BuySticker.vue?vue&type=template&id=76c7d686&scoped=true"
import script from "./BuySticker.vue?vue&type=script&lang=js"
export * from "./BuySticker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c7d686",
  null
  
)

export default component.exports